

import ParticlesBackground from '../../components/ParticlesBackground';
import './Home.css';

function Home() {
  return (
    <main className="home-main">
      <section className="home-hero">
        <ParticlesBackground />
        <div className="home-hero-gradient">
          <div className="content-wrapper">
            <h1 className="home-hero-title">Conoce cómo está el mercado y cuáles son las estrategias de la competencia a solo un clic de distancia  </h1>
            <p className="home-hero-desc">LicitData te permite acceder a los movimientos del mercado de forma ágil, precisa y confiable, facilitando la toma de decisiones en procesos de cotización de licitaciones.</p>
            <a href="/licitaciones/buscar" className="btn btn-light btn-hero">
              Explorar licitaciones
            </a>
          </div>
        </div>
      </section>
      {/* Segundo contenedor: Paso a paso */}
      <section className="howto-section">
        <div className="howto-left">
          <span className="howto-label">¿Cómo lo hago?</span>
          <h2 className="howto-title">Conoce el paso a paso para poder guiar tus cotizaciones y poder ofrecer una propuesta comercial competitiva.</h2>
        </div>
        <div className="howto-steps">
          <div className="step-item">
            <div className="step-icon step-number">1</div>
            <div className="step-content">
              <h3 className="step-title">Busca el servicio que necesites</h3>
              <p className="step-desc">Selecciona la opción Licitaciones del menú superior y luego selecciona Búsqueda.</p>
            </div>
          </div>
          <div className="step-item">
            <div className="step-icon step-number">2</div>
            <div className="step-content">
              <h3 className="step-title">Filtra tus necesidades</h3>
              <p className="step-desc">Con ayuda de los filtros, selecciona las opciones que mejor se adapten a tus requerimientos para mostrarte resultados alineados a estos.</p>
            </div>
          </div>
          <div className="step-item">
            <div className="step-icon step-number">3</div>
            <div className="step-content">
              <h3 className="step-title">Accede al dashboard</h3>
              <p className="step-desc">Utiliza el dashboard para visualizar y analizar los datos relevantes que te ayudarán a tomar decisiones informadas.</p>
            </div>
          </div>
          <div className="step-item">
            <div className="step-icon step-number">4</div>
            <div className="step-content">
              <h3 className="step-title">Analiza</h3>
              <p className="step-desc">Toma la mejor decisión con base a la información que te presentamos y tus conocimientos previos.</p>
            </div>
          </div>
          <div className="step-item">
            <div className="step-icon step-number">5</div>
            <div className="step-content">
              <h3 className="step-title">Entrega de cotización</h3>
              <p className="step-desc">Estás listo para ofrecer una cotización competitiva y alineada a la necesidades del cliente y del mercado.</p>
            </div>
          </div>
        </div>
      </section>
      {/* Sección de video mejorada */}
      <section className="video-section" aria-label="Video introductorio">
        <div className="video-container">
          <div className="video-header">
            <span className="video-badge">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445z"/>
              </svg>
              Tutorial en Video
            </span>
            <h2 className="video-title">Descubre cómo funciona LicitData</h2>
            <p className="video-subtitle">
              Aprende en menos de 3 minutos cómo aprovechar todas las funcionalidades 
              de nuestra plataforma para tomar mejores decisiones de negocio
            </p>
          </div>
          
          <div className="video-card">
            <div className="video-frame">
              <iframe
                src="https://www.youtube-nocookie.com/embed/iecZpysyDP0?rel=0&modestbranding=1"
                title="Video introductorio LicitData"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                referrerPolicy="strict-origin-when-cross-origin"
              />
            </div>
            <div className="video-overlay"></div>
          </div>

          <div className="video-features">
            <div className="video-feature">
              <div className="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                  <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                </svg>
              </div>
              <div>
                <h4>Interfaz Intuitiva</h4>
                <p>Fácil de usar desde el primer momento</p>
              </div>
            </div>
            
            <div className="video-feature">
              <div className="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M1 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3zm5-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2z"/>
                </svg>
              </div>
              <div>
                <h4>Análisis Confiable</h4>
                <p>Datos actualizados constantemente</p>
              </div>
            </div>
            
            <div className="video-feature">
              <div className="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383-4.708 2.825L15 11.105V5.383zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741zM1 11.105l4.708-2.897L1 5.383v5.722z"/>
                </svg>
              </div>
              <div>
                <h4>Reportes Detallados</h4>
                <p>Exporta y comparte información clave</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Home;
